import Service from '@ember/service';

// Logging Service: Centralizes logging for the application so we can filter it or direct it as we please.

export default class LoggingService extends Service {
  log(...args) {
    //eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    console.log(...args);
  }
  info(...args) {
    //eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    console.info(...args);
  }
  warn(...args) {
    //eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    console.warn(...args);
  }
  error(...args) {
    //eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    console.error(...args);
  }
  time(label?: string) {
    console.time(label);
  }
  timeEnd(label?: string) {
    console.timeEnd(label);
  }
}
declare module '@ember/service' {
  interface Registry {
    logger: LoggingService;
  }
}
